export const PasswordConstants = {
  PasswordChanged: 'PASSWORD_CONSTANTS.PASSWORD_SUCCESS',
  PasswordFailure: 'PASSWORD_CONSTANTS.PASSWORD_FAILURE',
  ClearStatus: 'PASSWORD_CONSTANTS.CLEAR_STATUS',
};

export const ProfileConstants = {
  ProfileUpdated: 'PROFILE_CONSTANTS.PROFILE_UPDATED',
  ProfileFailure: 'PROFILE_CONSTANTS.PROFILE_FAILURE',
  SetProfile: 'PROFILE_CONSTANTS.SET_PROFILE',
  ClearStatus: 'PROFILE_CONSTANTS.CLEAR_STATUS',
};
